module.exports = __webpack_public_path__ + "img/timeline_miscevent-15.22743280.jpg";